<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">مواعيد العيادات الخارجية وساعات الخدمة</h3>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="2">الفئة</th>
                            <th colspan="2">مواعيد العيادات الخارجية وساعات الخدمة</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">تطبيق الخدمة</td>
                            <td rowspan="2">أيام الأسبوع</td>
                            <td>الصباح</td>
                            <td>08:30 ~ 11:45</td>
                        </tr>
                        <tr>
                            <td>بعد الظهر	</td>
                            <td>12:30 ~ 16:45</td>
                        </tr>
                        <tr>
                            <td rowspan="2">ساعات الخدمة</td>
                            <td rowspan="2">أيام الأسبوع</td>
                            <td>الصباح</td>
                            <td>09:00 ~ 12:00</td>
                        </tr>
                        <tr>
                            <td>بعد الظهر</td>
                            <td>13:00 ~ 17:00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ لا توجد خدمات أيام السبت
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>